module.exports = "- Load React in script tag\n\n- ReactDOM to render to DOM\n"


//////////////////
// WEBPACK FOOTER
// ./src/slides/04_hello_world/notes_3.md
// module id = 1474
// module chunks = 0